// Static data for categories to avoid CORS issues
export const categories = [
  {
    id: 1,
    name: "Sports",
    description: "Sporting events and activities"
  },
  {
    id: 2,
    name: "Tech",
    description: "Technology meetups and workshops"
  },
  {
    id: 3,
    name: "Arts",
    description: "Art exhibitions and performances"
  },
  {
    id: 4,
    name: "Food",
    description: "Food tastings and cooking classes"
  },
  {
    id: 5,
    name: "Outdoor",
    description: "Outdoor activities and adventures"
  }
]; 